export default class AbstractService {
    /**
     * Constructor
     */
    constructor(store) {
        this.store = store;
    }
    /**
     * Returns the current user's id
     */
    get userId() {
        const user = this.store.getters['authentication/user'];
        return user ? user.id : null;
    }
    /**
     * Returns the authentication token for authenticated tasks
     */
    get token() {
        return this.store.getters['authentication/token'];
    }
}
//# sourceMappingURL=abstract-service.js.map